<template>
  <div class="result-con">
    <div class="main-wrapper">
      <div class="info-name"><span>{{name}}</span>是一位</div>
      <!-- <div class="type">是一位【{{result}}型】的乡村{{position}}</div> -->
      <div class="type"><span class="result-type">【{{result}}型】</span><span class="result-title1">的老师</span></div> 
      <div class="type-img" :style="{backgroundImage: typeImgUrl}"></div>
      <div class="type-text">
        <div :class="index == 0?'text-first':'text-item'" v-for="(item,index) in text_arr" :key="index">{{item}}</div>
        <div class="tips" v-if="shareImg!=''">长按保存图片</div>
      </div>
      
    </div>
    <div class="toast-btns">
        <div class="toast-report" @click="toReport()"></div>
        <div class="toast-recommend" @click="toRecommend()"></div>
        <div class="toast-share" @click="shareH5()"></div>
      </div>
    <div class="up-btn" :class="this.up == false?'uptodown':''" @click="upToast()"></div>
    <div
      class="up-wrapper"
      :class="this.show_toast == false?this.first?'':'hide-toast':'show-toast'"
    >
      <div class="down-btn" @click="downToast()"></div>
      <div class="model-text">
        <div>你是孩子们的榜样，</div>
        <div>现在申报2020年马云乡村教育人才计划</div>
        <div>用行动告诉孩子们：</div>
        <div>每个人都可以很棒！</div>
      </div>
      
    </div>
    <div class="share-con"></div>
    <div class="masking" v-if="show_share" @click="shareH5"></div>
    <div class="shareimg" v-if="show_share"></div>
    <div class="share-figure" v-if="show_share"></div>
    <div class="share-talk"  v-if="show_share"></div>
    <canvas class="my-canvas" id="canvas" width="750" height="1334" ref="canvas"></canvas>
    <img class="share-img" :src="shareImg" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      result: "",
      // position: "",
      name: "",
      typeImgUrl: "",
      text_arr: "",
      str1: "",
      str2: "",
      str3: "",
      str4: "",
      str5: "",
      str6: "",
      up: true,
      show_toast: false,
      first: true,
      show_share: false,
      shareImg: ""
    };
  },
  methods: {
    shareH5() {
      if (this.show_share) {
        this.show_share = false;
      } else {
        this.show_share = true;
      }
    },
    replay() {
      this.$router.push({
        name: "Home"
      });
    },
    upToast() {
      this.up = false;
      this.show_toast = true;
      this.first = false;
    },
    downToast() {
      this.up = true;
      this.show_toast = false;
    },
    toReport() {
      window.location.href = "https://www.mayun.xin/index.html#/program/education";
    },
    toRecommend() {
      window.location.href = "https://jinshuju.net/f/CUa7AY";
    },
    createCanvasImg() {
      let canvas = this.$refs.canvas;
      let ctx = canvas.getContext("2d");
      //画背景
      let bg = new Image();
      bg.src = require("../assets/images/canvas-bg.png");
      bg.onload = () => {
        ctx.drawImage(bg, 0, 0, 750, 1334);
        //logo
        let logo = new Image();
        logo.src = require("../assets/images/logo.png");
        logo.onload = () => {
          ctx.drawImage(logo, 299.5, 30, 151, 44);
          //人物插画
          let figure = new Image();
          if (this.result == "幸福") {
            figure.src = require("../assets/images/xf.png");
          } else if (this.result == "信念") {
            figure.src = require("../assets/images/xn.png");
          } else if (this.result == "智慧") {
            figure.src = require("../assets/images/zh.png");
          } else if (this.result == "影响") {
            figure.src = require("../assets/images/yx.png");
          }
          figure.onload = () => {
            ctx.drawImage(figure, 101, 296, 550, 580);
            //二维码
            let qrcode = new Image();
            qrcode.src = require("../assets/images/qrcode.png");
            qrcode.onload = () => {
              ctx.drawImage(qrcode, 36, 1162, 144, 140);
              //绘制底部图
              let bottom = new Image();
              bottom.src = require("../assets/images/bottom.png");
              bottom.onload = () => {
                ctx.drawImage(bottom, 235, 1210, 490, 78);
                //绘制文字
                ctx.beginPath();
                let title1 = '是一位'
                ctx.fillStyle = "#414141";
                ctx.font = "bold 40px PH-M";
                ctx.textAlign = "left";
                ctx.textBaseline = "middle";
                let name_width = ctx.measureText(this.name).width;
                let title1_width = ctx.measureText(title1).width;
                ctx.fillText(this.name, 100, 165);
                ctx.font = "bold 32px PH";
                ctx.fillText(title1, 100 + name_width, 165);
                //绘制类型文字
                ctx.fillStyle = "#ff6100";
                ctx.font = "bold 80px PH";
                ctx.textAlign = "left";
                ctx.textBaseline = "middle";
                let result_width = ctx.measureText(this.result).width;
                ctx.fillText(
                  "【" + this.result + "型】",
                  60,
                  235
                );
                ctx.fillStyle = "#414141";
                ctx.textAlign = "left";
                ctx.font = "32px PH";
                ctx.fillText('的老师', 265 + result_width, 255);
                //绘制描述文字
                ctx.fillStyle = "#414141";
                ctx.font = "bold 36px PH";
                ctx.textAlign = "center";
                ctx.textBaseline = "top";
                ctx.fillText(this.str1, 375, 915);
                ctx.fillStyle = "#414141";
                ctx.font = "33px PH";
                ctx.textAlign = "center";
                ctx.textBaseline = "top";
                ctx.fillText(this.str2, 375, 965);
                ctx.fillText(this.str3, 375, 1015);
                // ctx.fillText(this.str4, 375, 1035);
                // ctx.fillText(this.str5, 375, 1075);
                // if (this.result != "yx") {
                //   ctx.fillText(this.str6, 375, 1115);
                // }
                //转换图片
                let base64_ = canvas.toDataURL("image/png");
                let that = this;
                $.ajax({
                  type: "POST",
                  url: "https://m.xiaoxxx.com/h5/dingding/upload",
                  data: {
                    base64: base64_
                  },
                  dataType: "json",
                  success: function(res) {
                    that.shareImg = "http://" + res.data.url;
                  }
                });
              };
            };
          };
        };
      };
    }
  },
  created() {
    let result = this.$route.query.result;
    if (result == "xf") {
      this.result = "幸福";
      this.typeImgUrl = "url(" + require("../assets/images/xf.png") + ")";
      this.str1 = "有了爱，便有了一切。";
      this.str2 = "你享受着每一天的教育生活，";
      this.str3 = "看见孩子，就像看到了早晨的太阳。";
      this.str4 = "感受他们每一天的变化，";
      this.str5 = "用爱帮助乡村孩子";
      this.str6 = "成为最好的自己";
      this.text_arr = [
        this.str1,
        this.str2,
        this.str3,
        // this.str4,
        // this.str5,
        // this.str6
      ];
    } else if (result == "xn") {
      this.result = "信念";
      this.typeImgUrl = "url(" + require("../assets/images/xn.png") + ")";
      this.str1 = "眼望云端，胸怀千阳。";
      this.str2 = "你对乡村教育充满着信心，";
      this.str3 = "努力为乡村孩子提供更好的教育。";
      this.str4 = "阳光、坚定地让每个乡村孩子";
      this.str5 = "成为最好的自己！";
      this.text_arr = [this.str1, this.str2, this.str3,];
    } else if (result == "zh") {
      this.result = "智慧";
      this.typeImgUrl = "url(" + require("../assets/images/zh.png") + ")";
      this.str1 = "相识相学，相辅相成。";
      this.str2 = "你热爱思考，";
      this.str3 = "尝试各种方法克服教学中的困难。";
      this.str4 = "尊重和平等对待每个学生，";
      this.str5 = "激发每个乡村孩子";
      this.str6 = "成为最好的自己";
      this.text_arr = [
        this.str1,
        this.str2,
        this.str3,
        // this.str4,
        // this.str5,
        // this.str6
      ];
    } else if (result == "yx") {
      this.result = "影响";
      this.typeImgUrl = "url(" + require("../assets/images/yx.png") + ")";
      this.str1 = "不做唯一，只为唤醒。";
      this.str2 = "你拥有开放宽容的教育态度，";
      this.str3 = "能凝聚学生与团队。";
      this.str4 = "引领更多老师";
      this.str5 = "让每个乡村孩子";
      this.str6 = "成为最好的自己";
      this.text_arr = [
        this.str1,
        this.str2,
        this.str3,
        // this.str4,
        // this.str5,
        // this.str6
      ];
    }
    this.name = sessionStorage.getItem("name");
  },
  mounted() {
    this.createCanvasImg();
    setTimeout(() => {
      this.upToast();
    },3000)
  }
};
</script>

<style>
.result-con {
  width: 100%;
  height: 100vh;
  background-image: url("../assets/images/canvas-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  text-align: center;
  overflow: hidden !important;
}
.info-name {
  box-sizing: border-box;
  text-align: left;
  padding-left: 1.2rem;
  font-size: 0.32rem;
  color: #414141;
  font-weight: bold;
}
.info-name span {
  font-family: 'PH-M';
  color: #666666;
  font-size: 0.4rem;
  font-weight: bolder;
}
.type {
  box-sizing: border-box;
  font-size: 0.32rem;
  font-weight: bold;
  text-align: left;
  padding-left: 1rem;
  color: #414141;
}
.result-type {
  font-size: 0.8rem;
  color: #ff6100;
  font-weight: bolder;
  font-family: "PH-M";
  margin-left: -0.2rem;
}
.type .result-title1 {
  margin-left: -0.4rem;
}
.type-img {
  width: 5.02rem;
  height: 5.31rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  margin: 0.2rem auto;
}
.type-text {
  margin-top: 0.2rem;
}
.text-item {
  font-size: 0.3rem;
}
.btn-con {
  position: relative;
  /* margin-top: 0.2rem; */
  width: 100%;
  height: 1rem;
  bottom: 0;
  text-align: center;
  z-index: 200;
}
.share-btn {
  display: inline-block;
  width: 2.48rem;
  height: 0.85rem;
  background-image: url("../assets/images/share-btn.png");
  background-size: cover;
  background-repeat: no-repeat;
  vertical-align: middle;
  margin: 0 0.2rem;
}
.repaly-btn {
  display: inline-block;
  width: 2.48rem;
  height: 0.85rem;
  background-image: url("../assets/images/replay.png");
  background-size: cover;
  background-repeat: no-repeat;
  vertical-align: middle;
  margin: 0 0.2rem;
}
.up-btn {
  position: absolute;
  bottom: 3%;
  left: 50%;
  transform: translateX(-50%);
  width: 0.62rem;
  height: 0.52rem;
  background-image: url("../assets/images/up.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.up-wrapper {
  position: fixed;
  bottom: -5.5rem;
  width: 7.5rem;
  height: 5.14rem;
  background-image: url("../assets/images/up-wrapper.png");
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 20;
}
.down-btn {
  position: absolute;
  width: 0.62rem;
  height: 0.34rem;
  top: 0.26rem;
  left: 50%;
  transform: translateX(-50%);
  background-image: url("../assets/images/down.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.model-text {
  position: absolute;
  top: 0.9rem;
  width: 100%;
  text-align: center;
  font-size: 0.3rem;
}
.toast-btns {
  position: fixed;
  bottom: 11%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-top: 3.2rem; */
  z-index: 999;
}
.toast-report {
  width: 2.01rem;
  height: 0.7rem;
  background-image: url("../assets/images/report.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.toast-recommend {
  width: 2.01rem;
  height: 0.7rem;
  background-image: url("../assets/images/recommend.png");
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0 0.2rem;
}
.toast-share {
  width: 2.01rem;
  height: 0.7rem;
  background-image: url("../assets/images/toast-share.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.uptodown {
  animation-name: up-to-down;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: forwards;
}
.show-toast {
  animation-name: show-toast;
  animation-duration: 0.5s;
  animation-timing-function: linear;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: forwards;
}
.hide-toast {
  animation-name: hide-toast;
  animation-duration: 0.5s;
  animation-timing-function: linear;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: forwards;
}
.masking {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  z-index: 100;
}
.shareimg {
  position: fixed;
  right: 0;
  top: 0;
  width: 2.47rem;
  height: 1.92rem;
  background-image: url("../assets/images/share-icon.png");
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 101;
}
.share-figure {
  position: fixed;
  right: 1.5rem;
  top: 3rem;
  width: 4.09rem;
  height: 6.4rem;
  background-image: url("../assets/images/share-figure.png");
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 101;
}
.share-talk {
  position: fixed;
  right: 2.5rem;
  top: 0.8rem;
  width: 3.27rem;
  height:2.3rem;
  background-image: url("../assets/images/talk.png");
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 101;
}
#canvas {
  display: none;
  position: relative;
  z-index: 999;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.share-img {
  position: fixed;
  width: 100%;
  height: 80%;
  top: 0;
  left: 0;
  /* transform: translateY(-50%); */
  opacity: 0;
  z-index: 1;
}
.tips {
  width: 100%;
  text-align: center;
  color: #ff6100;
  font-size: 0.24rem;
  margin-top: 0.5rem;
}
.text-first {
  font-size: 0.36rem;
  font-weight: 800;
}
@keyframes show-toast {
  from {
    bottom: -5.5rem;
  }
  to {
    bottom: 0;
  }
}
@keyframes up-to-down {
  from {
    bottom: 5%;
    opacity: 1;
  }
  to {
    bottom: -10%;
    opacity: 0;
  }
}
@keyframes hide-toast {
  from {
    bottom: 0;
  }
  to {
    bottom: -5.5rem;
  }
}
</style>